import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { FUNNEL_DATA } from '../data/mockData';

// 区块3：从试讲到课堂的转化漏斗
export default function ChartFunnel() {
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '从试讲到课堂：师范生能力转化漏斗',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c}%',
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      data: FUNNEL_DATA.map((d) => d.name),
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 13 },
    },
    series: [
      {
        name: '能力转化',
        type: 'funnel',
        left: '10%',
        top: 60,
        bottom: 60,
        width: '80%',
        min: 0,
        max: 100,
        minSize: '0%',
        maxSize: '100%',
        sort: 'descending',
        gap: 2,
        label: {
          show: true,
          position: 'inside',
          formatter: '{b}\n{c}%',
          color: '#0f172a',
          fontSize: 14,
          fontWeight: 'bold',
        },
        labelLine: { length: 10, lineStyle: { width: 1, type: 'solid' } },
        itemStyle: { borderColor: '#0f172a', borderWidth: 2 },
        emphasis: { label: { fontSize: 16 } },
        data: FUNNEL_DATA.map((item, index) => ({
          ...item,
          itemStyle: {
            color: ['#fbbf24', '#f97316', '#06b6d4', '#22c55e', '#a855f7'][index],
          },
        })),
        animationDuration: 1500,
        animationEasing: 'cubicOut',
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 480 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
